const locationSelection = document.querySelector<HTMLElement>( '#location-selection' );
const whereSelect = document.querySelector<HTMLSelectElement>( 'select#where' );

if ( locationSelection && whereSelect ) {
    locationSelection.classList.add( 'd-none' );

    whereSelect.addEventListener( 'input', function() {
        if ( whereSelect.value === 'Home-based' || whereSelect.value === '' ) {
            locationSelection.classList.add( 'd-none' );
        } else {
            locationSelection.classList.remove( 'd-none' );
        }
    } );
}
